module.exports = __webpack_public_path__ + "img/bg1.754d9f58.jpg";